import { get123WellnessData } from "./get123WellnessData";
import { getSuperadminData } from "./getSuperAdminData";

export const fetchData = async (
  state,
  user,
  wellness,
  anonamizeData,
  options = {},
) => {
  try {
    let results = {
      districts: {},
      allWellnessPoints: [],
      allStudents: [],
      studentData: {},
      currentDictionary: initEmotionDictionary(),
      compareDictionary: initEmotionDictionary(),
      loading: false,
      counter: 0,
    };
    if (!user || !user.role) {
      return results;
    }

    const promise = (async () => {
      switch (user.role) {
        case "123wellness":
          return await get123WellnessData(state, user, wellness);
        case "superadmin":
          return await getSuperadminData(
            user,
            wellness,
            anonamizeData,
            options,
          );
        case "admin":
          return await getSuperadminData(user, wellness, undefined, options);
        case "teacher":
          return await getSuperadminData(user, wellness, undefined, options);
        default:
          return results;
      }
    })();

    const data = await promise;

    return data;
  } catch (error) {
    throw error;
  }
};

function initEmotionDictionary() {
  return {
    sad: 0,
    tired: 0,
    lonely: 0,
    happy: 0,
    grateful: 0,
    calm: 0,
    stressed: 0,
    scared: 0,
    angry: 0,
  };
}
